import { render, staticRenderFns } from "./SojaParaguai.vue?vue&type=template&id=868e2140&lang=pug"
import script from "./SojaParaguai.vue?vue&type=script&lang=js"
export * from "./SojaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports